import { render, staticRenderFns } from "./CanteensHome.vue?vue&type=template&id=89178a8a&scoped=true&"
import script from "./CanteensHome.vue?vue&type=script&lang=js&"
export * from "./CanteensHome.vue?vue&type=script&lang=js&"
import style0 from "./CanteensHome.vue?vue&type=style&index=0&id=89178a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89178a8a",
  null
  
)

export default component.exports